import React from 'react';
import { useTheme } from '../../../contexts/ThemeContext';

interface AuthLayoutProps {
  children: React.ReactNode;
  className?: string;
}

export function AuthLayout({ children, className = '' }: AuthLayoutProps) {
  const { theme } = useTheme();

  return (
    <div
      className={`min-h-screen flex flex-col justify-center px-6 py-12 lg:px-8 ${className}`}
      style={{
        background: theme === 'dark'
          ? 'radial-gradient(ellipse at center, var(--storgia-dark-blurple) 0%, var(--storgia-black) 100%)'
          : 'radial-gradient(ellipse at center, var(--storgia-light-blurple) 0%, var(--storgia-white) 100%)'
      }}
    >
      {children}
    </div>
  );
}
